goog.provide('el8.appchart.dialog.reconcileCdaImportDemographics');

goog.require('el8.appservice.notifier');
goog.require('el8.ptdata.hccScoreDetails');
goog.require('el8.service.tz');
goog.require('el8.template.appchart.dialog.reconcileCdaImportDemographics');
goog.require('el8.uiwidget.ButtonSet');
goog.require('el8.uiwidget.NewDialog');


/**
 * A version of reconcileCdaImport specifically for Demographics,
 * which is a dictionary, rather than a list, and has a more explicit notion
 * of "before vs. after"
 */
el8.appchart.dialog.reconcileCdaImportDemographics = (function() {

    var callbackFn = null;
    var summaryId = null;
    var importJson = null;

    var that = new el8.uiwidget.NewDialog({
        width: 570,
        autoHeight: true,
        position: 'center'
    });

    var buttonSet = new el8.uiwidget.ButtonSet();
    buttonSet.addButton(
        'save', 'Import & Reconcile', importCheckedItems, true
    );
    buttonSet.addButton(
        'cancel', 'Cancel', function() {
            that.hide();
        }, false
    );
    that.setButtonSet(buttonSet);

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);

        that.getContentElt().on('click', '.importable-checkbox',  function(e) {
            var $this = $(this);
            $this.closest('.importable-div').toggleClass('el8BlueHighlightList');

            e.stopPropagation(); // we don't need to trigger .importable-div after this

        }).on('click', '.importable-div',  function() {
            var $this = $(this);
            $this.toggleClass('el8BlueHighlightList');
            var checkBox = $this.find('input');
            checkBox.prop('checked', !checkBox.is(':checked')); //toggle the checkbox's state

        });
    };

    var super_show = that.show;
    that.show = function(spec) {
        super_show.call(that);

        summaryId = spec.summaryId;
        importJson = spec.importJson;
        callbackFn = spec.callbackFn || null;

        if (!el8.data.races.length || !el8.data.ethnicities.length) {
            $.el8_ajax({
                url: el8.service.urls.get('patientFormInfo'),
                type: 'GET',
                async: false,
                success: function(data) {
                    el8.data.phoneTypes = $.parseJSON(data['phone_types']);
                    el8.data.races = $.parseJSON(data['races']);
                    el8.data.ethnicities = $.parseJSON(data['ethnicities']);
                }
            });
        }

        var racesMap = {};
        el8.data.races.forEach(function(race) {
            racesMap[race[0]] = race[1];
        });
        var ethnicitiesMap = {};
        el8.data.ethnicities.forEach(function(ethnicity) {
            ethnicitiesMap[ethnicity[0]] = ethnicity[1];
        });
        that.setContent(
            el8.template.appchart.dialog.reconcileCdaImportDemographics.content({
                patient: el8.ptdata.currPatient.asSoyMap(),
                importJson: importJson,
                racesMap: racesMap,
                ethnicitiesMap: ethnicitiesMap
            })
        );
        $(':input[type="checkbox"]:checked', that.getContentElt())
            .closest('.importable-div')
            .addClass('el8BlueHighlightList');

        that.setTitle('Reconcile Demographics');
        that.adjustPosition();
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);

        callbackFn = null;
        summaryId = null;
        importJson = null;

        that.getContentElt().empty();
    };


    function importCheckedItems() {
        var checkedInputs = $(':input[type="checkbox"]:checked', that.getContentElt());
        var checkedKeys = [];
        checkedInputs.each(function(i, elt) {
            var key = $(elt).data('key');
            if (key === 'full_name') {
                checkedKeys = checkedKeys.concat(['first_name', 'middle_name', 'last_name']);
            } else if (key === 'full_address') {
                checkedKeys = checkedKeys.concat(['address1', 'address2', 'city', 'state', 'zip']);
            } else {
                checkedKeys.push(key);
            }
        });
        if (!checkedKeys.length) { that.hide(); } // like cancelling if the user deselected everything
        el8.util.amplitude.logCcdaImportSection('demographics');
        el8.appservice.notifier.notify('Importing data from patient summary...');
        $.el8_ajax({
            type: 'POST',
            url: el8.service.urls.get('stageImportXmlSummary', [el8Globals.PATIENT_ID, summaryId, 'demographics_complete']),
            data: JSON.stringify({ keys_to_import: checkedKeys }),
            success: function(data) {
                if (callbackFn) { callbackFn(data); }
                el8.appservice.notifier.notify('Data from patient summary imported.');
                el8.ptdata.hccScoreDetails.refreshIfHccScoreEnabled();
                that.hide();
            }
        });

    }


    return that;

})();
